import React, { useState, useEffect } from 'react';
import AddPartner from './AddPartner';
import ViewPartner from './ViewPartner';
import { useFormikContext } from 'formik';
import { getPartnersInBusinessIncome } from '../../../../common/constants/api';
import PopUp from '../../../../common/components/PopUp/PopUp';
import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';
import * as _ from 'lodash';
const Partner = () => {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    validateForm
  } = useFormikContext();
  const [showFiles, setShowFiles] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState(false);
  const [state, setState] = useState('viewPartner');
  const [preValues, setPreValues] = useState(values.preValues());
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);
  const [partnerList, setPartnerList] = useState([]);
  const [stateData, setStateData] = useState(false);

  const handleGetPartners = () => {
    setType('loading');
    setText('Getting uploaded data Please Wait..');
    setShow(true);

    getPartnersInBusinessIncome(
      getApplicantionInfo().leadId,
      getApplicantionInfo().leadApplicantId
    )
      .then(res => {
        if (res.error) {
          throw new Error(res);
        }
        setShow(false);
        setPartnerList(res);
      })
      .catch(error => {
        setType('fail');
        setText(_.get(error, 'response.data.message', 'something went wrong!'));
        setShow(true);
      });
  };
  useEffect(() => {
    if (state == 'viewPartner') {
      handleGetPartners();
    }
  }, [state]);

  useEffect(() => {
    if (preValues?.companyDetails?.companyType != 'Partnership') {
      handleSubmit();
    }
  }, []);
  return (
    <div className="w-full px-5 my-6">
      {state == 'addPartner' ? (
        <AddPartner setState={setState} stateData={stateData} />
      ) : null}
      {state == 'viewPartner' ? (
        <ViewPartner
          each={partnerList}
          setShowFiles={setShowFiles}
          setUploadedFiles={setUploadedFiles}
          setState={setState}
          setStateData={setStateData}
          handleGetPartners={handleGetPartners}
        />
      ) : null}
      <PopUp type={type} text={text} setShow={setShow} show={show} />
    </div>
  );
};

export default Partner;
